import { render, staticRenderFns } from "./FormForgotPasswordProfessional.vue?vue&type=template&id=8979dd12&scoped=true"
import script from "./FormForgotPasswordProfessional.vue?vue&type=script&lang=js"
export * from "./FormForgotPasswordProfessional.vue?vue&type=script&lang=js"
import style0 from "./FormForgotPasswordProfessional.vue?vue&type=style&index=0&id=8979dd12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8979dd12",
  null
  
)

export default component.exports